import React from 'react';
import UnifiedGallery from '../components/UnifiedGallery';
import useStandardGallery from '../hooks/useStandardGallery';

const WeddingPage = () => {
  // Use standardized gallery hook with custom configuration for grid layout
  const { getGalleryProps, loading } = useStandardGallery('wedding', {
    layout: {
      columns: 4,           // Force 4 photos per row
      thumbnailSize: 180,   // Smaller thumbnails for more columns
      spacing: 'compact'    // Less space between photos
    }
  });

  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-heart"></i>
          Family Wedding Gallery
        </h1>
        <p>A collection of precious wedding moments from our family history. These photos capture the joy, love, and traditions that have been passed down through generations.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="wedding-content">
            <p className="welcome-text">
              A collection of precious wedding moments from our family history. 
              These photos capture the joy, love, and traditions that have been 
              passed down through generations of the Rossetti and De Marco families.
            </p>

            {/* Loading indicator */}
            {loading && (
              <div className="loading-indicator">
                <i className="fas fa-spinner fa-spin"></i>
                Loading photos...
              </div>
            )}
          </div>
        </div>

        {/* Wedding Photo Gallery */}
        <div className="section">
          <UnifiedGallery 
            {...getGalleryProps("matrimonio,  marriage,  casamiento")}
          />
        </div>
      </div>
    </div>
  );
};

export default WeddingPage;